import BaseStore from './BaseStore'

export class ActingStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'actings'
  }
}

export default new ActingStore()


// WEBPACK FOOTER //
// ./src/stores/ActingStore.js